<template>
  <section id='getData' class='section'>
    <div class="title">Data Export</div>
      <div class="field">
        <label class="label">Select School / College</label>
        <div class="control">
          <div class="select" :class='{"is-loading": isOrgsLoading}'>
            <select v-model="orgId">
              <option disabled value="0">-- Select --</option>
              <option v-for="org in orgs" :value="org.id">{{ org.name }}</option>
            </select>
          </div>
        </div>
      </div>

    </div>
    <p class='control'>
      <button class='button is-info' :class='{"is-loading": isLoading}' @click='getData()'>Export Data</button>
    </p>
    <br>
  <div v-if='msg' class='notification is-info'>{{msg}}</div>
  </section>
</template>

<script>

export default {
  name: 'getData',
  data() {
    return {
      isLoading: false,
      isReset: false,
      error: {
        email: this.msgAlias,
      },
      email: '',
      msg: '',
      orgId: 0,
      isOrgsLoading: true,
      orgs: [],
    };
  },
  methods: {
    resetFields() {
      Object.assign(this.$data, this.$options.data.call(this));
      this.isReset = true;
    },
    getData() {
      this.isLoading = true;
      this.$http.get(`/scarf/all-results/${this.orgId}`, {
        params: {
          token: this.$user.token,
        },
      })
        .then((res) => {
          this.isLoading = false;
          // console.log('data:', res.data);
          const blob = new Blob([res.data], { type: 'text/csv' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `${String(new Date()).substring(4, 24).replace(/[: ]/g, '-')}.csv`;
          document.body.append(link);
          link.click();
        });
    },
    getOrgs() {
      this.isOrgsLoading = true;
      this.$http.get('/scarf/orgs', {
        params: {
          token: this.$user.token,
        },
      })
        .then((res) => {
          this.isOrgsLoading = false;
          this.orgs = res.data.data;
        });
    },
  },
  created() {
    this.getOrgs();
  },
};
</script>

<style scoped>
.button, .button:hover {
  background-color: #47a0db;
}
</style>



// WEBPACK FOOTER //
// src/components/Data.vue